import React from 'react';
import { TextField, SelectField, DatePicker } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

const FORM_NAME = 'report_payment_form';

let reportPaymentForm = props => {
  const { handleSubmit, tenants } = props;

  const tenant_list = tenants.map(tenant => (
    <MenuItem value={tenant['value']} primaryText={tenant['label']} />
  ));

  return (
    <div>
      <form onSubmit={handleSubmit.bind(this)} id="form_field">
        <div className="row">
          <div className="row">
            <div className="col-xs-6" style={{ margin: 'auto' }}>
              <Field
                name="payment_date"
                component={DatePicker}
                openToYearSelection={true}
                style={{
                  marginTop: '-20px',
                  fontSize: '14px',
                  textAlign: 'left',
                  width: '100%',
                }}
                formatDate={formatter.reformatDate}
                autoOk={true}
                textFieldStyle={{ width: '100%', fontSize: '14px' }}
                floatingLabelText="Payment Date"
                validate={[validator.required]}
              />
            </div>
            <div className="col-xs-6" style={{ margin: 'auto', marginTop: '-5px' }}>
              <Field
                name="batch_id"
                component={TextField}
                floatingLabelText="Batch Id"
                multiLine={false}
                fullWidth
                style={{ marginTop: '-15px', fontSize: '14px' }}
              />
            </div>
            <div className="col-xs-6" style={{ margin: 'auto' }}>
              <Field
                name="payment_type"
                component={SelectField}
                floatingLabelText="Payment Type"
                style={{
                  marginTop: '-20px',
                  fontSize: '14px',
                  textAlign: 'left',
                  width: '100%',
                }}
                validate={[validator.required]}
                maxHeight={200}
              >
                <MenuItem value={'Cash'} primaryText={'Cash'} />
                <MenuItem value={'Cheque'} primaryText={'Cheque'} />
                <MenuItem value={'Credit Card'} primaryText={'Credit Card'} />
                <MenuItem value={'eTransfer'} primaryText={'eTransfer'} />
                <MenuItem value={'ODSP'} primaryText={'ODSP'} />
                <MenuItem value={'Pre-Auth Debit'} primaryText={'Pre-Auth Debit'} />
              </Field>
            </div>
            <div className="col-xs-6" style={{ margin: 'auto', marginTop: '-5px' }}>
              <Field
                name="reference_number"
                component={TextField}
                floatingLabelText="Reference No."
                multiLine={false}
                fullWidth
                validate={[validator.required]}
                style={{ marginTop: '-15px', fontSize: '14px' }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6" style={{ margin: 'auto', marginTop: '-5px' }}>
              <Field
                name="amount"
                component={TextField}
                floatingLabelText="Amount Received"
                multiLine={false}
                fullWidth
                validate={[validator.required, validator.greaterThanZero]}
                warn={validator.maxPaymentReport}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                {...formatter.currencyMask}
              />
            </div>
            <div className="col-xs-6" style={{ margin: 'auto' }}>
              <Field
                name="paid_by"
                component={SelectField}
                floatingLabelText="Paid By"
                style={{
                  marginTop: '-20px',
                  fontSize: '14px',
                  textAlign: 'left',
                  width: '100%',
                }}
                validate={[validator.required]}
                maxHeight={200}
              >
                {tenant_list}
              </Field>
            </div>
          </div>
        </div>
        <div
          className="row"
          style={{
            textAlign: 'center',
            margin: 'auto',
            marginTop: '10px',
            marginBottom: '10px',
          }}
        >
          <FlatButton
            label="Report Payment"
            type="submit"
            className="Report Payment"
            primary={true}
            hoverColor="grey"
            disabled={props.isSubmitting}
            backgroundColor={props.isSubmitting ? colors.GRAY : AccentColor()}
            style={{ color: 'white', height: '40px' }}
          />
        </div>
      </form>
    </div>
  );
};

export default reduxForm({
  form: FORM_NAME,
  fields: ['amount', 'id', 'amount_outstanding'],
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(reportPaymentForm);
